import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { CITTA } from "@/data/citta";

export function Citta() {
  return (
    <section id="citta" className="border-y border-slate-800 bg-abyss py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="text-center">
          <p className="overline-label">Dove interveniamo</p>
          <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Attivi in <span className="text-amber-400">tutta la Lombardia</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-slate-400">
            Tecnici dislocati in ogni provincia: per questo riusciamo a essere da te in
            pochi minuti, a qualsiasi ora del giorno e della notte.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {CITTA.map((c, i) => (
            <Reveal key={c.slug} delay={(i % 4) * 0.07}>
              <Link
                to={`/citta/${c.slug}`}
                data-testid={`citta-link-${c.slug}`}
                className="group flex h-full flex-col justify-between rounded-2xl border border-slate-800 bg-slatecard p-6 text-center transition-all duration-300 hover:-translate-y-1 hover:border-amber-500/50 hover:shadow-[0_16px_50px_rgba(0,0,0,0.45)]"
              >
                <div className="flex items-start justify-between">
                  <MapPin size={20} className="text-amber-400" />
                  <ArrowUpRight
                    size={18}
                    className="text-slate-600 transition-all group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-amber-400"
                  />
                </div>
                <div className="mt-8">
                  <h3 className="font-display text-xl font-bold text-white">
                    Pronto intervento {c.nome}
                  </h3>
                  <p className="mt-2 font-mono text-xs uppercase tracking-[0.15em] text-slate-500">
                    Servizio attivo H24/7
                  </p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
